<div id="lineChartCanvas" >
    <canvas #lineChartCanvas class="customWidth" width="400" height="400"></canvas>
</div>
